"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountSettingsBlank = exports.AccountSettingsRequestDTOSchema = exports.AccountSettingsDTO = exports.AccountSettingsSchema = exports.AccountSettingsBaseSchema = void 0;
var zod_1 = require("zod");
var CommonMongoModelFields_1 = require("./lib/CommonMongoModelFields");
exports.AccountSettingsBaseSchema = zod_1.z.object({
    Title: zod_1.z.string().min(2, 'The title must contain at least 2 letters'),
    CompanyName: zod_1.z.string().min(2, 'The company name must contain at least 2 letters'),
    AccountNumber: zod_1.z.string().min(2, 'The account number must contain at least 2 letters'),
    IBAN: zod_1.z.string().min(2, 'The IBAN must contain at least 2 letters'),
    BankDetails: zod_1.z.string().min(2, 'Bank details must contain at least 2 letters'),
    BIC: zod_1.z.string().min(2, 'The BIC must contain at least 2 letters'),
});
exports.AccountSettingsSchema = exports.AccountSettingsBaseSchema.extend(CommonMongoModelFields_1.CommonMongoModelFields);
var AccountSettingsDTOSchema = exports.AccountSettingsSchema.extend(CommonMongoModelFields_1.CommonModelDTOFields);
exports.AccountSettingsDTO = {
    convertFromModel: function (model) {
        var dto = {
            _id: model._id.toString(),
            createdAt: model.createdAt,
            updatedAt: model.updatedAt,
            Title: model.Title,
            CompanyName: model.CompanyName,
            AccountNumber: model.AccountNumber,
            IBAN: model.IBAN,
            BankDetails: model.BankDetails,
            BIC: model.BIC,
        };
        return dto;
    },
};
exports.AccountSettingsRequestDTOSchema = AccountSettingsDTOSchema.extend(CommonMongoModelFields_1.CommonModelRequestDTOFields);
exports.AccountSettingsBlank = {
    Title: '',
    CompanyName: '',
    AccountNumber: '',
    IBAN: '',
    BankDetails: '',
    BIC: '',
};
//# sourceMappingURL=AccountSettings.js.map